'use client'

import { useConvexAuth } from 'convex/react'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'

export function usePostHogAuth() {
  const { isAuthenticated, isLoading } = useConvexAuth()
  const posthog = usePostHog()
  const user = useQuery(api.auth.currentUser)

  useEffect(() => {
    if (!posthog || isLoading) return

    if (isAuthenticated && user) {
      // Identify the user in PostHog with real user data
      posthog.identify(user._id, {
        email: user.email,
        name: user.name,
        image: user.image,
      })
    } else if (!isAuthenticated) {
      // Reset PostHog when user signs out
      posthog.reset()
    }
  }, [isAuthenticated, isLoading, user, posthog])
}